"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Key = void 0;
var React = require("react");
var Key = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9.99 9", style: __assign({ height: '20px', width: '20px' }, style) },
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { className: "cls-1", d: "M7.06,0A2.82,2.82,0,0,0,4.38,2.61a2.9,2.9,0,0,0,.15,1.11L0,8a.21.21,0,0,0,0,.1v.79A.14.14,0,0,0,.14,9H1.86A.14.14,0,0,0,2,8.89l.16-.69L2.93,8A.13.13,0,0,0,3,7.92l.1-.58.77-.22A.14.14,0,0,0,4,7V6.35l.65-.16a.16.16,0,0,0,.1-.11l.11-.66a.88.88,0,0,0,.9-.19,2.78,2.78,0,0,0,1.52.38A2.81,2.81,0,1,0,7.06,0ZM7,2.77a.93.93,0,1,1,.92-.92A.93.93,0,0,1,7,2.77Z" })))));
};
exports.Key = Key;
//# sourceMappingURL=Key.js.map